import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=28a41614"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
import style0 from "./Layout.vue?vue&type=style&index=0&id=28a41614&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports